module.exports = __webpack_public_path__ + "static/media/(V)_MG_6060_-_Cia_Termal_Beachewear_-_Moda_Bebe.bbbc749e.jpg";